import { takeLatest, SagaGenerator } from 'typed-redux-saga'

import { BiometriaTypes } from './types'
import {
  getBiometricsValidateSaga,
  getBiometricActiveSaga,
  getUseNewProvidersSaga,
  postBiometriaDadosSaga,
  generateIdUnicoLinkSaga,
  getSeedSaga,
  postValidateBiometricsSaga,
} from './sagas'

export default function* watch(): SagaGenerator<void> {
  yield* takeLatest(BiometriaTypes.POST_BIOMETRICS_SAVE, postBiometriaDadosSaga)
  yield* takeLatest(BiometriaTypes.GET_VALIDATE_BIOMETRICS, getBiometricsValidateSaga)
  yield* takeLatest(BiometriaTypes.GET_BIOMETRIC_ACTIVE, getBiometricActiveSaga)
  yield* takeLatest(BiometriaTypes.GET_USE_NEW_PROVIDERS, getUseNewProvidersSaga)
  yield* takeLatest(BiometriaTypes.GENERATE_ID_UNICO_LINK_REQUEST, generateIdUnicoLinkSaga)
  yield* takeLatest(BiometriaTypes.SEED_REQUEST, getSeedSaga)
  yield* takeLatest(BiometriaTypes.POST_VALIDATE_BIOMETRICS, postValidateBiometricsSaga)
}
